import React from "react";
import { connect } from "react-redux";

import {
  fetchMoreResults,
} from "./redux";

import Results from "./Results";

const ResultsContainer = ({
  campaigns,
  hasMoreResults,
  isLoading,
  isLoadingMore,
  onLoadMore,
}) => (
  <Results
    isLoading={isLoading}
    isLoadingMore={isLoadingMore}
    campaigns={campaigns}
    onLoadMore={onLoadMore}
    hasMoreResults={hasMoreResults}
  />
);

export default connect(
  // map state to props
  ({ results }) => ({
    isLoading: results.isFetching,
    isLoadingMore: results.isFetchingMore,
    hasMoreResults: results.nextCursor,
    campaigns: results.data,
  }),
  // map dispatch to props
  (dispatch) => ({
    onLoadMore: () => {
      dispatch(fetchMoreResults());
    },
  }),
)(ResultsContainer);
